<template>
  <div>
    <ServiceContent></ServiceContent>
    <VehicleExpenses id="service"></VehicleExpenses>
    <!--    <centered-auto-swiper />-->
    <!--    <car-service id="service" />-->
    <!--    <choose-us id="choose" />-->
  </div>
</template>

<script>
// import ChooseUs from '@/components/Moudle/CarService/ChooseUs.vue'
import ServiceContent from '@/components/Moudle/CarService/ServiceContent.vue'
// import CarService from '@/components/Moudle/CarService/CarService.vue'
import VehicleExpenses from '@/components/Moudle/CarService/VehicleExpenses.vue'
export default {
  components: { ServiceContent, VehicleExpenses },
  data() {
    return {}
  },
  mounted() {
    if (this.$route.query.type == 2) {
      this.$nextTick(() => {
        let top = document.getElementById('service').offsetTop
        window.scrollTo({ top: top, behavior: 'smooth' })
      })
    }
  }
}
</script>

<style scoped lang="scss"></style>
